/**
 * The different states the application can be in.
 *
 * Used by the AppModel to determine.
 */
export enum AppState {
    MAIN_MENU,
    IN_GAME,
    OPTIONS,
    FILTER,
    CREDITS,
    QA,
}
